// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cbOZ","colBig":"styles_colBig__1e4K_","colSmall":"styles_colSmall__tZS2m"};